<template>
    <p v-for="error of errors" :key="error.$uid">
        <strong>{{ error.$validator }}</strong>
        <small> en </small>
        <strong>{{ error.$property }}</strong>
        <small> : </small>
        <strong>{{ error.$message }}</strong>
    </p>
</template>

<script>
export default {
    props: ['errors']
}
</script>

<style>

</style>